export const IMAGE_QUERY_FIELDS = `
    title
    description
    contentType
    url
    width
    height
    sys { id }
`;

export const EXPANDER_QUERY_FIELDS = `
    name
    title
    content {
      json
    }
`;

export const COMPONENT_TITLE_TEXT_QUERY = `
    title
    content {
      json
    }
`;

export const COMPONENT_LINK_QUERY = `
    sys { id }
    __typename
    text
    link {
    ... on PageGeneral {
      __typename
      slug
    }
    ... on PageProduct {
      __typename
      slug
    }
    ... on PageCollection {
      __typename
      slug
      imageMobile {
        ${IMAGE_QUERY_FIELDS}
      }
      imageDesktop {
        ${IMAGE_QUERY_FIELDS}
      }
    }
    ... on PageAdvice {
      __typename
      slug
    }
    ... on PageProductBundle {
      __typename
      slug
    }
    ... on PageFaqHub {
      __typename
      urlSlug
    }
    }
    externalLink
    pageReload
`;

export const GLOBAL_COMPONENT_LINK_QUERY = `
    sys { id }
    __typename
    text
    link {
    __typename
    ... on PageGeneral {
        slug
    }
    ... on PageProduct {
        slug
    }
    ... on PageCollection {
        slug
    }
    ... on PageAdvice {
        slug
    }
    ... on PageProductBundle {
        slug
    }
    ... on PageFaqHub {
        urlSlug
    }
    }
    externalLink
    pageReload
`;

export const LINK_QUERY_FIELDS = `
__typename
... on ComponentLink{
  __typename
  link{
    ... on PageGeneral{
      __typename
      slug
    }
    ... on PageProduct{
      __typename
      slug
    }
    ... on PageCollection{
      __typename
      slug
    }
    ... on PageAdvice{
      __typename
      slug
    }
    ... on PageProductBundle{
      __typename
      slug
    }
  }
  externalLink
  pageReload
}
... on PageGeneral{
  __typename
  slug
}
... on PageProduct{
  __typename
  slug
}
... on PageCollection{
  __typename
  slug
}
... on PageAdvice{
  __typename
  slug
}
... on PageProductBundle{
  __typename
  slug
}
`;

export const VIDEO_QUERY_FIELDS = `
title
url
contentType
`;

export const NEWSLETTER_QUERY_FIELDS = `
    title
    bodyText
    inputText
    successMessage
    failedMessage
    mailChimpListId
`;

export const KLAVIYO_COMPONENT_FIELDS = `
    name
    formId
`;

export const COMPONENT_MEDIA_FIELDS_QUERY = `
  __typename
  sys {
    id
  }
  type
  imageDesktop {
    ${IMAGE_QUERY_FIELDS}
  }
  imageMobile {
    ${IMAGE_QUERY_FIELDS}
  }
  thumbnailImage {
    ${IMAGE_QUERY_FIELDS}
  }
  thumbnailImageDesktop {
    ${IMAGE_QUERY_FIELDS}
  }
  video {
    ${VIDEO_QUERY_FIELDS}
  }
  videoDesktop {
    ${VIDEO_QUERY_FIELDS}
  }
  videoAspectRatio
  objectFit
  focalPoint
  link {
    ... on PageGeneral {
      __typename
      slug
    }
    ... on PageProduct {
      __typename
      slug
    }
    ... on PageProductBundle {
      __typename
      slug
    }
    ... on PageCollection {
      __typename
      slug
    }
  }
  externalLink
`;

export const COMPONENT_MEDIA_QUERY = `
  ... on ComponentMedia {
    ${COMPONENT_MEDIA_FIELDS_QUERY}
  }
`;

export const COMPONENT_MENU_QUERY = `
... on ComponentMenu {
  __typename
  sys {
    id
  }
  title
  linksCollection(limit: 10){
    items {
      ${GLOBAL_COMPONENT_LINK_QUERY}
    }
  }
}
`;

export const COMPONENT_SUBMENU_QUERY = `
... on ComponentSubmenu {
  __typename
  sys {
    id
  }
  title
  type
  menusCollection(limit: 3){
    items {
      ${COMPONENT_MENU_QUERY}
    }
  }
  link {
    ${GLOBAL_COMPONENT_LINK_QUERY}
  }
}
`;

export const COMPONENT_NAVBAR_QUERY = `
  ... on ComponentNavbar {
    __typename
    sys {
      id
    }
    name
    submenusCollection(limit: 8){
      items {
        ${COMPONENT_SUBMENU_QUERY}
      }
    }
  }
`;

export const COMPONENT_BUTTON_QUERY = `
__typename
name
style
title
color
link {
${LINK_QUERY_FIELDS}
}
subtitle
customColor{
  color
}
customTextColor{
  color
}
`;

export const PRODUCT_SPEC_QUERY_FIELDS = `
    name
    type {
      name
      filterType
    }
    value
`;

export const RESOURCE_QUERY_FIELDS = `
    title
    source
    text
    multipleTexts
    richText {
      json
    }
    componentLink {
      ${COMPONENT_LINK_QUERY}
    }
    image {
      ${IMAGE_QUERY_FIELDS}
    }
    componentNewsletter {
      ${NEWSLETTER_QUERY_FIELDS}
    }
    componentKlaviyoForm {
      ${KLAVIYO_COMPONENT_FIELDS}
    }
    mediaCollection(limit: 10) {
      items {
        ${COMPONENT_MEDIA_QUERY}
      }
    }
    componentLink {
      ${COMPONENT_LINK_QUERY}
    }
    menusCollection(limit: 7) {
      items {
        ${COMPONENT_MENU_QUERY}
        ${COMPONENT_SUBMENU_QUERY}
      }
    }
`;

export const COMPONENT_TEXT_WITH_ICON_QUERY = `
  ... on ComponentTextWithIcon {
    __typename
    sys {
      id
    }
    name
    text
    icon {
      ${IMAGE_QUERY_FIELDS}
    }
  }
`;

export const COMPONENT_BLOG_CATEGORY_QUERY = `
  ... on ComponentBlogCategory {
    __typename
    sys {
      id
    }
    name
    title
    categoryType
  }
`;

export const COMPONENT_BLOG_ARTICLE_QUERY = `
  ... on ComponentBlogArticle {
    __typename
    sys {
      id
    }
    name
    articleType
    headlineImage {
      ${COMPONENT_MEDIA_QUERY}
    }
    articleLink {
      text
      link {
        ... on PageGeneral {
          __typename
          slug
          name
        }
      }
      externalLink
    }
  }
`;

export const RICH_TEXT_WITH_ASSETS_FIELDS = `
json
links {
  assets {
    block {
      __typename
      sys {
        id
      }
      ${IMAGE_QUERY_FIELDS}
    }
  }
  entries {
    block {
      ${COMPONENT_MEDIA_QUERY}
    }
  }
}
`;

export const SEO_QUERY = `
  ... on ComponentSeo {
    title
    description
    image {
      ${IMAGE_QUERY_FIELDS}
    }
    keywords
    robots
    schemaType
    schemaTypeNew
  }
`;

export const COMPONENT_SOCIAL_LINK_QUERY = `
  ... on ComponentSocialLink {
    __typename
    sys {
      id
    }
    name
    socialIcon {
      ${IMAGE_QUERY_FIELDS}
    }
    link
  }
`;

export const COMPONENT_SINGLE_PROMISE_QUERY = `
  ... on ComponentSinglePromise {
    __typename
    sys {
      id
    }
    name
    title
    image {
      ${COMPONENT_MEDIA_QUERY}
    }
    subtext
  }
`;

export const COMPONENT_CTA_STEP_QUERY = `
  ... on ComponentCtaStep {
    __typename
    sys {
      id
    }
    name
    headline
    body {
      json
    }
    media {
      ${COMPONENT_MEDIA_QUERY}
    }
    button {
      ${COMPONENT_BUTTON_QUERY}
    }
    style
  }
`;

export const COMPONENT_COUNTRY_SELECTOR_ITEM = `
  ... on ComponentCountrySelectorItem {
    __typename
    sys {
      id
    }
    name
    countryCode
    slug
    externalLink
    relatedCountries
    defaultLanguage
  }
`;
export const COLLABORATOR_QUERY_FIELDS = ` 
  name
  slug
  avatar {
    ${IMAGE_QUERY_FIELDS}
  }
  title
  subtitle
  description {
    json
  }
  socialsCollection(limit: 10) {
    items {
      ${COMPONENT_SOCIAL_LINK_QUERY}
    }
  }
`;

export const ADVICE_PAGE_SLUG = 'advice';
export const ADVICE_PAGE_LIMIT = 12;
